import React, { useContext, useEffect, useState } from "react";
import "./customerlogin.scss";
import logo from "../../logo.jpeg";
import { Button, DatePicker, Input } from "antd";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Notification } from "../../components/notification/notification";
import PlatformFooter from "../../components/footer/footer";
import { LoginOutlined } from "@ant-design/icons";
import { UserModulesAccessState } from "../../types/types";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { UrlConstants } from "../../utils/ApiConstants";
import { InputOTP } from "antd-input-otp";
import ReactSelect from "react-select";
import { GetRequest, replaceWithCurrentApiVersion } from "../../utils/api";
import { EXTERNAL_USER_INFO } from "../../screens/users/states/actionTypes";
import { Layout } from 'antd';
import { MenuContext } from "../../MenuProvider";
interface Props {
  isLogin?: (val: any) => void;
}

interface Financer {
  value: string;
  label: string;
}

const { Content } = Layout;

const CustomerLogin: React.FC<Props> = ({ isLogin }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { menuItems, setMenuItems } = useContext(MenuContext);

  const rootState = useSelector((state: any) => state?.initialReducer);

  const [forms, setForms] = useState("");
  const [loanNoDisabled, setLoanNoDisabled] = useState<boolean>(false);
  const [customerDetailsDisabled, setCustomerDetailsDisabled] =
    useState<boolean>(false);
  const [financerRecords, setFinancerRecords] = useState<Financer[]>([])
  const [financier, setFinancier] = useState(null)
  const [
    showCustomerDetailsVerificationForm,
    setShowCustomerDetailsVerificationForm,
  ] = useState<boolean>(false);
  const [showLoanNumberVerificationForm, setShowLoanNumberVerificationForm] =
    useState<boolean>(false);
  const [showOTPVerificationForm, setShowOTPVerificationForm] =
    useState<boolean>(false);
  const [otp, setOTP] = useState<string[]>([]);
  const [loanNo, setLoanNo] = useState<string>("");
  const [otpSessionId, setOtpSessionId] = useState<string>("");
  const moduleAccessState: UserModulesAccessState = useSelector(
    (state: any) => state?.userAccessReducer
  );

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const campaignId = queryParams.get('campaignId');



  const submitForm = async (values: any) => {
    // console.log(values);
    setFinancier(values.financier.value);

    try {
      await axios.post(
        UrlConstants.BASE_URL + `auth/guest/api/validate/loan`,
        { loanNumber: values.loanno, financier: values.financier.value, campaignId: campaignId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          // Assuming you want to access the response data
          if (response.status === 200) {
            setLoanNoDisabled(true);
            setShowLoanNumberVerificationForm(false);
            setShowCustomerDetailsVerificationForm(true);
            setForms(values.loanno);
            setLoanNo(values.loanno);

          } else {
            throw Error();
          }
        });
    } catch (error) {
      Notification("error", "Please Enter Valid loan Number");
    }
  };
  const loginCustomer = async (values: any) => {
    // console.log(values.dob.format("YYYY-MM-DD"), "logincoustomer");
    try {
      await axios.post(
        UrlConstants.BASE_URL + `auth/guest/api/validate/loan`,
        {
          loanNumber: values.loanno,
          dob: values.dob.format("YYYY-MM-DD"),
          panNo: values.panno,
          financier: financier,
          campaignId: campaignId
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          // Assuming you want to access the response data
          let status = response.status;
          if (status !== 200) {
            Notification("error", "Provided Pan Number or date of birth is not matchingwith our records.");
          } else {

            Notification(
              "success",
              "Verification of details was successful. Kindly input the OTP you've received, either on your email or mobile."
            );

            setCustomerDetailsDisabled(true);
            setOtpSessionId(response.data.sessionId);
            setShowOTPVerificationForm(true);
            setShowCustomerDetailsVerificationForm(false);
            // generateOTP();
          }
        });
    } catch (error) {
      Notification("error", "Provided Pan Number or date of birth is not matchingwith our records.");
    }
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();


  const { login: data } = rootState;

  const removeSpaces = (value: any) => {
    return value.replace(/\s/g, ""); // Replace all spaces with empty strings
  };
  // Navigate to login only on success....
  useEffect(() => {
    if (
      data.data &&
      !data.loading &&
      data.data !== "Bad Request" &&
      data.data != "Unauthorized"
    ) {

      // Login was successful, so let's send the websocket request
      // if (mainMenuLinks.length === 0) dispatch(getMenuLinksInfoForUser({}));
      GetRequest('users/menulinks').then((menuResponse: any) => {
        setMenuItems(menuResponse.records);
      });

    }
  }, [data.data]);


  useEffect(() => {
    fetchFinanceMaster()
  }, [campaignId])

  useEffect(() => {
    if (financerRecords.length) {
      // console.log("FinancierRecords   ", financerRecords)
      setShowLoanNumberVerificationForm(true);
    }
  }, [financerRecords])

  const fetchFinanceMaster = async () => {
    try {
      await axios
        .get(UrlConstants.BASE_URL + replaceWithCurrentApiVersion('auth/guest/api/financier-master?campaignId=' + campaignId + '&size=50&page=0'))
        .then((response) => {
          const transformedData: Financer[] = response.data.records.map((record: any) => ({
            value: record.financierCode,
            label: record.financierName
          }));
          setFinancerRecords(transformedData)
        });
    } catch (error) {
      console.log(error)
      Notification("error", "Invalid or expired campaign,please provide the active campaign id.");
    }
  }

  const resendOtp = async () => {
    try {
      await axios
        .post(UrlConstants.BASE_URL + `auth/otp/resend`,
          {
            "sessionId": otpSessionId
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          })
        .then((response) => {
          // console.log(response);
          if (response.status == 200) {
            setOtpSessionId(response.data.sessionId);
            Notification("success", "Otp sent succesfully");
          } else {
            Notification("error", "Failed to resend otp, Please try again");
          }
        });
    } catch (error) {
      Notification("error", "Failed to resend otp, Please try again");
    }
  };

  const validateOTP = async () => {
    try {
      await axios
        .post(UrlConstants.BASE_URL + `auth/otp/validate`,
          {
            "otp": `${otp.join('')}`,
            "sessionId": otpSessionId
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          })
        .then((response) => {
          // console.log(response);
          if (response.status == 200) {
            localStorage.setItem("user", JSON.stringify(response.data));
            dispatch({
              type: EXTERNAL_USER_INFO,
              payload: { campaignId: campaignId },
            });

            GetRequest('users/menulinks').then((menuResponse: any) => {
              setMenuItems(menuResponse.records);
              navigate(`/waiverSettlement/onlineWaiver`, { state: { loanNo: loanNo } });
            });


            Notification(
              "success",
              "Login Successful."
            );
          }
        });
    } catch (error) {
      Notification("error", "OTP is not valid, Please try again");
    }
  };

  return (
    <>

      <Layout style={{ height: "100vh" }}>

        <Layout style={{ height: "100%" }}>

          <Content>
            <div className="login-container">
              <div className="login-aside">
                <h1>PEWISE</h1>
              </div>
              <div className="login-auth">
                <div className="my-4">
                  <img src={logo} alt="Bharat Collect" style={{width : "340px", height : "auto"}} />
                </div>
                <div className="loginCard">
                  {showOTPVerificationForm && (
                    <>
                      <div>
                        <InputOTP length={4} onChange={setOTP} value={otp} />
                      </div>
                      <div>
                        <a href="#" className="mt-2" onClick={resendOtp} style={{ marginLeft: '130px' }} >Resend OTP?</a>
                      </div>
                      <div>
                        <Button type="primary" className="mt-3" onClick={validateOTP}>Validate OTP</Button>
                      </div>
                    </>

                  )}
                  {showCustomerDetailsVerificationForm && (
                    <form onSubmit={handleSubmit(loginCustomer)}>
                      <div className="text-left mb-2">
                        <div>
                          <label>Loan No:</label>
                          <Controller
                            name="loanno"
                            control={control}
                            rules={{
                              required: "Loan no is required",
                            }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                disabled={loanNoDisabled}
                                maxLength={50}
                                {...field}
                                onChange={(e) =>
                                  field.onChange(removeSpaces(e.target.value))
                                }
                              />
                            )}
                          />
                          {errors.loanno && (
                            <p className="ant-form-item-explain-error">
                              Please enter valid Loan Number
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="text-left my-2">
                        <div>
                          <label>Pan No:</label>
                          <Controller
                            name="panno"
                            control={control}
                            rules={{
                              required: "pan no is required",
                              pattern: {
                                value: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                                message: "Invalid email address",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                disabled={customerDetailsDisabled}
                                maxLength={50}
                                {...field}
                                onChange={(e) =>
                                  field.onChange(removeSpaces(e.target.value))
                                }
                              />
                            )}
                          />
                          {errors.panno && (
                            <p className="ant-form-item-explain-error">
                              Please enter valid pan Number
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="text-left my-2">
                        <div>
                          <label>Date Of Birth:</label>
                          <Controller
                            name="dob"
                            control={control}
                            rules={{
                              required: "Date Of Birth is required",
                              // pattern: {
                              //   value: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                              //   message: 'Invalid email address',
                              // },
                            }}
                            render={({ field }) => (
                              <DatePicker
                                className="datepicker notranslate"
                                disabled={customerDetailsDisabled}
                                {...field}
                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="btn-container">
                        <Button className="mt-2" type="primary" htmlType="submit" block>
                          <span>
                            Verify Personal Details <LoginOutlined className="mx-2" rev={undefined} />
                          </span>
                        </Button>
                      </div>
                    </form>
                  )}
                  {showLoanNumberVerificationForm && (
                    <form onSubmit={handleSubmit(submitForm)}>
                      <div className="text-left">
                        <div>
                          <label>Loan No:</label>
                          <Controller
                            name="loanno"
                            control={control}
                            rules={{
                              required: "Loan no is required",
                            }}
                            render={({ field }) => (
                              <Input
                                type="text"
                                maxLength={50}
                                {...field}
                                onChange={(e) =>
                                  field.onChange(removeSpaces(e.target.value))
                                }
                                className="mt-1 mb-2"
                              />
                            )}
                          />
                          {errors.loanno && (
                            <p className="ant-form-item-explain-error">
                              Please enter valid Loan Number
                            </p>
                          )}
                        </div>
                        <div>
                          <label>Financier:</label>
                          <Controller
                            name="financier"
                            control={control}
                            rules={{ required: "Financier is required" }}
                            render={({ field }) => (
                              <ReactSelect
                                {...field}
                                options={financerRecords}
                                className="mt-1 mb-2"
                              />
                            )}
                          />
                          {errors.financiers && (
                            <p className="ant-form-item-explain-error">
                              Please select any financier
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="btn-container">
                        <Button type="primary" className="mt-2 login-btn" htmlType="submit" block>
                          <span>
                            Verify Loan Number <LoginOutlined rev={undefined} />
                          </span>
                        </Button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>

          </Content>

        </Layout>

        <PlatformFooter />
      </Layout>


    </>
  );
};

export default CustomerLogin;
